__turbopack_context__.v({
  "card": "styles-module__4_mBGq__card",
  "img": "styles-module__4_mBGq__img",
  "imgContainer": "styles-module__4_mBGq__imgContainer",
  "publishedAt": "styles-module__4_mBGq__publishedAt",
  "title": "styles-module__4_mBGq__title",
});
